import { isSign,listByUser,list,add,updateSelf,user,listSelf,getTeamsByUser,listSubUser,
    listSelfA,infoSelf,aftersalesAdd,infoByUser,cancelSelf,confirmSelf,remarkInfoByUser,
    buygoods,bookingListByUser,bookingInfoByUser,addressListByUser,favListByUser,InfoFavActive,
    deleteByUserFav,addByUserFav,myApplyToCash,BookingCancel,setdefault,addressInfo,addressUpdate,
    addressAdd,addressDelete,CardInfoByUser,CardUpdateUser,orderOn,userInfo,updateaddress,ordersSubmit,
    getPaystatus,getSalesmanStat,deleteCard,addInvoiceAddress,getDefAddress,invoiceListByUser,invoiceAdd,
    invoiceUpdate,invoiceSetdefault,dictList,invoiceDelete,transferInfo,invoiceInfo,infoByMainOrderNo,
    orderShare,listSelfB,dictExpressList,orderExpressAdd,changePayStatus
} from '@/api/personal'


const actions = {
  isSign(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
          isSign(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listByUser(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
          listByUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    list(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            list(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    add(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            add(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateSelf(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            updateSelf(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    user(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            user(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listSelf(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listSelf(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getTeamsByUser(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            getTeamsByUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getSalesmanStat(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            getSalesmanStat(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listSubUser(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listSubUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listSelfA(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listSelfA(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listSelfB(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listSelfB(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    infoSelf(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            infoSelf(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    infoByMainOrderNo(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            infoByMainOrderNo(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    aftersalesAdd(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            aftersalesAdd(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    infoByUser(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            infoByUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    cancelSelf(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            cancelSelf(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    confirmSelf(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            confirmSelf(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    remarkInfoByUser(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            remarkInfoByUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    buygoods(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            buygoods(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    bookingListByUser(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            bookingListByUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    bookingInfoByUser(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            bookingInfoByUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    addressListByUser(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            addressListByUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    favListByUser(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            favListByUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    InfoFavActive(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            InfoFavActive(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    deleteByUserFav(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            deleteByUserFav(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    addByUserFav(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            addByUserFav(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    myApplyToCash(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            myApplyToCash(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    BookingCancel(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            BookingCancel(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    setdefault(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            setdefault(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    addressInfo(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            addressInfo(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    addressUpdate(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            addressUpdate(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    addressAdd(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            addressAdd(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    addressDelete(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            addressDelete(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    CardInfoByUser(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            CardInfoByUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    CardUpdateUser(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            CardUpdateUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    orderOn(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            orderOn(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    userInfo(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            userInfo(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateaddress(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            updateaddress(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    ordersSubmit(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            ordersSubmit(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getPaystatus(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            getPaystatus(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    deleteCard(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            deleteCard(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    addInvoiceAddress(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            addInvoiceAddress(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getDefAddress(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            getDefAddress(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    invoiceListByUser(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            invoiceListByUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    invoiceAdd(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            invoiceAdd(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    invoiceUpdate(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            invoiceUpdate(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    invoiceSetdefault(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            invoiceSetdefault(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    dictList(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            dictList(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    invoiceDelete(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            invoiceDelete(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    transferInfo(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            transferInfo(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    invoiceInfo(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            invoiceInfo(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    dictExpressList(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            dictExpressList(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    orderShare(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            orderShare(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    orderExpressAdd(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            orderExpressAdd(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    changePayStatus(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            changePayStatus(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },

}

export default {
  namespaced: true,
  actions
}
